import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataTableReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M3 15V16.5H6.4395L1.5 21.4395 2.5605 22.5 7.5 17.5605V21H9V15H3zM18 16.5H15V18H18V16.5zM15 13.5H12V15H15V13.5zM18 10.5H15V12H18V10.5zM9 10.5H6V12H9V10.5z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M20.25 2.25H3.75C3.35234 2.25054 2.97112 2.40874 2.68993 2.68993C2.40874 2.97112 2.25054 3.35234 2.25 3.75V12H3.75V8.25H20.25V20.25H12V21.75H20.25C20.6477 21.7495 21.0289 21.5913 21.3101 21.3101C21.5913 21.0289 21.7495 20.6477 21.75 20.25V3.75C21.7495 3.35234 21.5913 2.97112 21.3101 2.68993C21.0289 2.40874 20.6477 2.25054 20.25 2.25ZM20.25 6.75H3.75V3.75H20.25V6.75Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataTableReference.vue"]]);
